import { useConfig } from '@context/ConfigurationContext'
import { useLanguage } from './useLanguage'

export const useLinkToAnaParams = () => {
  const { sourceWebsite } = useConfig()
  const lang = useLanguage()
  const website = sourceWebsite || `${window.location.origin}${window.location.pathname}`
  const linkToAnaParams = `&lang=${lang}&sourceWebsite=${website}`

  return linkToAnaParams
}
